import { useState } from 'react'
import './VerticalSlider.css'

function VerticalSlider(props) {
    const {
        servoKiy,
        min,
        max,
        value,
        handelSliderChange,
        onMouseUpHandel,
        direction,
        isLargeThumb = false,
        isSliderBackground = false,
    } = props

    return (
        <div
            className={`sliderDiv ${direction === 'up-down' ? 'vertical_sliderDiv' : ''} ${isLargeThumb ? 'large_vertical_sliderDiv' : ''}`}
            // style={
            //     direction === 'up-down'
            //         ? {
            //               position: 'relative',
            //               marginLeft: '15px',
            //               height: '200px',
            //           }
            //         : { position: 'relative', marginLeft: '15px' }
            // }
        >
            <input
                type="range"
                min={min}
                max={max}
                value={value}
                className={`vertical_slider ${isLargeThumb ? 'large_thumb' : ''}`}
                onChange={(e) => {
                    handelSliderChange(servoKiy, e.target.value)
                }}
                onMouseUp={() => {
                    setTimeout(() => {
                        onMouseUpHandel()
                        // if (props.disable) return
                        // props.leftEyeData()
                    }, 200)
                }}
                style={
                    direction === 'up-down'
                        ? {
                              direction: 'initial',
                              position: 'absolute',
                              top: '20px',
                          }
                        : {}
                }
            />

            {isSliderBackground && (
                <div className="Vertiacl_slider_background" />
            )}

            <div
                // className="Vertiacl_slider__track"
                className={`Vertiacl_slider__track ${
                    isLargeThumb ? 'large_track' : ''
                }`}
                style={{ background: props.sliderBackGround }}
            />
        </div>
    )
}

export default VerticalSlider
